// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"6ee623b2","762":"cb68e99b"}[chunkId] + ".chunk.css";
};